<template>
  <div v-title :data-title="RecordType==1?'佣金记录':'提现记录'">
    <scroller
      :on-refresh="refresh"
      :on-infinite="infinite"
      style="padding-top:0px;"
      ref="myScroller"
    >
      <div class="page" :class="borwser!=''?'':'needtomargin-top'">
        <div class="weui-form-preview preview-item" v-for="model in orderlist" :key="model.Guid">
          <wv-media-box
            v-if="model.RecordType==3"
            type="text"
            title="提现"
            :description="'-￥'+model.Amount+' 余额：￥'+model.Balance"
          ></wv-media-box>
          <wv-media-box
            v-if="model.RecordType==1"
            type="text"
            :title="GetCommissionLevelName(model.CommissionLevel)"
            :description="'+￥'+model.Amount+' 余额：￥'+model.Balance"
            @click="toProduct(model.ProductGuid,model.DisGuid)"
          ></wv-media-box>
          <wv-media-box
            v-if="model.RecordType==5"
            type="text"
            title="退款"
            :description="'-￥'+model.Amount+' 余额：￥'+model.Balance"
            @click="toProduct(model.ProductGuid,model.DisGuid)"
          ></wv-media-box>
          <span
            v-if="model.RecordType==1||model.RecordType==3||model.RecordType==5"
            style="position: absolute;top: 25px;right: 10px; font-size:14px;color:#999"
          >{{model.CreateTime}}</span>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import thumb from "../../assets/logo.png";

export default {
  name: "withdrawalsrecord",
  data: function() {
    return {
      borwser: this.GLOBAL.borwser,
      PageNum: 1,
      PageSize: 10,
      formset: {},
      orderlist: [],
      thumb: thumb,
      RecordType: null
    };
  },
  created: function() {
    var url = window.location.href;
    var RecordType = this.$route.query.RecordType;
    if (
      RecordType != undefined &&
      RecordType != null &&
      RecordType.length > 0
    ) {
      this.RecordType = RecordType;
    }
    this.InitMessage(0);
  },
  methods: {
    onShow() {
      console.log("shown");
    },
    onHide() {
      console.log("hidden");
    },
    onQueryShow() {
      console.log("onQueryShow");
    },
    onQueryHide() {
      console.log("onQueryHide");
    },
    tabbarclick: function(to, index) {
      this.$router.push(to);
      this.isonindex = index;
    },
    GetCommissionLevelName: function(type) {
      switch(type)
      {
        case 1:return "分销佣金";
        case 2:return "一级团员分销佣金";
        case 3:return "二级团员分销佣金";
      }
      return "分销佣金";
    },
    toProduct: function(productGuid,disGuid) {
      this.$router.push({
        path: "/page/productdetail",
        query: {
          id: productGuid,
          disid: disGuid
        }
      });
    },
    InitMessage: function(type) {
      var data = {
        PageSize: this.PageSize,
        PageNum: this.PageNum,
        RecordType: this.RecordType
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/extract/getpager", data, {
          emulateJSON: true
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.formset = rep.Data;
            if (type != 1) {
              this.orderlist = [];
              this.formset.List.forEach(element => {
                this.orderlist.push(element);
              });
            } else {
              this.formset.List.forEach(element => {
                this.orderlist.push(element);
              });
            }
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    refresh: function(done) {
      //下拉
      var self = this;
      setTimeout(function() {
        self.PageNum = 1;
        self.InitMessage(0);
        done();
      }, 1500);
    },
    infinite: function(done) {
      var self = this;
      setTimeout(function() {
        self.PageNum += 1;
        self.InitMessage(1);
        done();
        if (self.formset.List.length == 0) {
          self.$refs.myScroller.finishInfinite(true);
          return;
        }
      }, 500);
    }
  }
};
</script>

<style>
.needtomargin-top {
  margin-top: 48px;
}
.popup {
  z-index: 9998;
  position: relative;
  background-color: #fff;
  line-height: 3em;
}

.search_left {
  width: 50%;
  text-align: center;
  font-size: 0.9em;
  float: left;
  background-color: #fff;
}
</style>






// WEBPACK FOOTER //
// src/components/mypurse/withdrawalsrecord.vue